<template>
  <div class="header nav-container nav-container--sidebar">
    <div class="nav-sidebar-column bg--primary-3">
      <div class="text-left text-block justify-content-center header__logo">
        <router-link :to="{name:'home'}">
          <img alt="SINBON" class="logo" :src="$data.siteUrl + '/img/logo.svg'" />
        </router-link>

        <strong class="nav-subtitle text-nowrap">{{ $t('nav_slogan') }}</strong>
      </div>

      <hr class="header__hr">

      <div class="text-block">
        <ul class="main-list menu-vertical">
          <li>
            <router-link :to="{ name:'solution',query:{ cate:'all',page:'1'} }">{{ $t('nav_solution') }}</router-link>
          </li>
          
          <li class="dropdown" v-if="navTrends != null && navTrends.children != undefined">
            <span class="dropdown__trigger">{{ $t('nav_trends') }}</span>

            <div class="dropdown__container">
              <div class="dropdown__content">
                <ul>
                  <li class="hiligh" v-for="item in navTrends.children">
                    <a :href="$data.siteUrl + item.uri">{{ item.title }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <li class="dropdown" v-else>
            <span class="dropdown__trigger">{{ $t('nav_trends') }}</span>

            <div class="dropdown__container">
              <div class="dropdown__content">
                <ul>
                  <li class="hiligh">
                    <router-link :to="{ name:'ev-charging'}">{{ $t('nav_evCharging') }}</router-link>
                  </li>

                  <li class="hiligh">
                    <router-link :to="{ name:'solar-system'}">{{ $t('nav_solarSystem') }}</router-link>
                  </li>

                  <li class="hiligh">
                    <router-link :to="{ name:'robotic'}">{{ $t('nav_robotic') }}</router-link>
                  </li>
                  
                  <li class="hiligh">
                    <router-link :to="{ name:'e-bike'}">{{ $t('nav_ebike') }}</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <!-- <li>
            <router-link :to="{ name:'casestudy',query:{ cate:'all',page:'1'} }" v-html="$t('nav_casestudy')">案例分享</router-link>
          </li>
          <li>
            <router-link :to="{ name:'blog',query:{ page:'1'} }" v-html="$t('nav_blog')">文章</router-link>
          </li> -->

          <li class="dropdown">
            <span class="dropdown__trigger">{{ $t('nav_products') }}</span>

            <div class="dropdown__container">
              <div class="dropdown__content">
                <ul v-if="navProducts != null" class="menu-vertical">
                  <li v-for="item in navOptions.children" :class="item.class">
                    <!-- 這個才是選單 -->
                    <!-- <a :href="$data.siteUrl + 'product?cate=' + item.uri + '&page=1'">{{ item.title }}</a> -->
                    <a :href="$data.siteUrl + 'product/'+item.uri+'?cate=' + item.uri + '&page=1'">{{ item.title }}</a>
                  </li>
                </ul>

                <ul v-else-if="productCats" class="menu-vertical">
                  <li>
                    <router-link :to="{ name:'product', query: { cate:'all', page: '1' } }">
                    <!-- 所有類別 -->
                    {{ $t('ui_allCategory') }}
                    </router-link>
                  </li>
                  <!-- 這個不知道什麼時候出現 -->
                  <!-- <li v-for="category in productCats" :key="category.id">
                    <router-link
                      :to="{ name:'product',query:{ cate:category.category_slug ,page:'1'} }"
                    >{{category.category_name}}</router-link>
                  </li> -->
                  <li v-for="category in productCats" :key="category.id">
                    <router-link
                      :to="{ name:'product',params:{category:category.category_slug},query:{ cate:category.category_slug ,page:'1'} }"
                    >{{category.category_name}}</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <li>
            <router-link :to="{ name:'distribution', query:{ cate:'all',page:'1'}}">{{ $t('nav_brands') }}</router-link>
          </li>

          <li class="dropdown">
            <span class="dropdown__trigger">{{ $t('nav_resources') }}</span>

            <div class="dropdown__container">
              <div class="dropdown__content">
                <ul class="menu-vertical">
                  <li>
                    <router-link :to="{ name:'brochure' }">{{ $t('nav_resourcesBrochure') }}</router-link>
                  </li>

                  <li>
                    <router-link :to="{ name:'webinar',query:{ cate:'all',page:'1'} }">{{ $t('nav_resourcesWebinar') }}</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <li class="dropdown">
            <span class="dropdown__trigger">
              <!-- 投資人專區 -->
               {{ $t('nav_investor') }}
            </span>
            <div class="dropdown__container">
              <div class="dropdown__content">
                <ul class="menu-vertical">
                  <li>
                    <router-link :to="{ name:'investors-news',params:{ page:'1'}}">
                      <!-- 投資人訊息 -->
                       {{ $t('nav_investorNewsroom') }}
                    </router-link>
                  </li>

                  <!-- should be removed -->
                  <!-- <li v-if="!headerPreview">
                    <router-link :to="{ name:'corporate-governance'}">
                    {{ $t('nav_investorGovernance') }}
                    </router-link>
                  </li> -->

                  <!--new nav-->
                  <!-- <li class="dropdown sub" v-if="navGovernance&&headerPreview"> -->
                  <li class="dropdown sub dropdown--governance" v-if="navGovernance">
                    <span class="dropdown__trigger">{{ $t('nav_investorGovernance') }}</span>

                    <div class="dropdown__container">
                      <div class="dropdown__content">
                        <ul>
                          <li class="hiligh" v-for="item in navGovernance" :data-uri="'/'+item.uri">
                            <router-link :to="{ name:'governance-page',params:{slug:item.uri.replace('governance/','')} }">{{ item.title }}</router-link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>

                  <li>
                    <router-link :to="{ name:'financial-info'}">
                      {{ $t('nav_investorFinancial') }}
                      <!-- 財務資訊 -->
                    </router-link>
                  </li>

                  <li>
                    <router-link :to="{ name:'shareholders-info' }">
                    <!-- 股東會資料 -->
                     {{ $t('nav_investorShareholder') }}
                    </router-link>
                  </li>

                  <li>
                    <router-link :to="{ name:'business-overview' }">
                      <!-- 公司營運概況 -->
                      {{ $t('nav_investorBusiness') }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <!-- should be removed -->
          <!-- <li class="dropdown" v-if="csrPage&&!headerPreview">
            <span class="dropdown__trigger">
              {{ $t('nav_csr') }}
            </span>

            <div class="dropdown__container">
              <div class="dropdown__content">
                <ul class="menu-vertical">
                  <li v-for="page in csrPage">
                    <router-link :to="{ name:'csr-page',params:{slug:page.slug} }">{{page.name}}</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name:'csr-report' }">{{ $t('nav_csrDownload') }}</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </li> -->

          <!--new nav-->
          <!-- <li class="dropdown" v-if="navEsg&&headerPreview"> -->
          <li class="dropdown dropdown--esg" v-if="navEsg">
            <span class="dropdown__trigger">{{ $t('nav_esg') }}</span>

            <div class="dropdown__container">
              <div class="dropdown__content">
                <ul class="menu-vertical">
                  <li v-for="item in navEsg" :class="item.children?'dropdown sub':''" :data-uri="'/'+item.uri">
                    <router-link v-if="!item.children" :to="{ name:'esg-page',params:{slug:item.uri.replace('esg/','')} }">{{item.title}}</router-link>
                  
                    <span v-if="item.children" class="dropdown__trigger">{{item.title}}</span>
                    <div v-if="item.children" class="dropdown__container">
                      <div class="dropdown__content">
                        <ul>
                          <li class="hiligh" v-for="child in item.children" :data-uri="'/'+child.uri">
                            <router-link :to="{ name:'esg-page',params:{slug:child.uri.replace('esg/','')} }">{{child.title}}</router-link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <!--new nav-->
          <!-- <li v-if="headerPreview"> -->
          <li>
            <router-link :to="{ name:'sustainability-report' }">{{ $t('nav_sustainability_report') }}</router-link>
          </li>

          <li>
            <a href="https://shop.sinbon.com/" target="_blank" v-html="$t('nav_ix')"></a>
          </li>
        </ul>

        <hr class="mt-0">

        <ul class="secondary-list menu-vertical h5">
          <li>
            <router-link :to="{ name:'news', query:{ cate:'all',page:'1'} }">{{ $t('nav_news') }}</router-link>
          </li>

          <li>
            <router-link :to="{ name:'global-location' }">{{ $t('nav_location') }}</router-link>
          </li>

          <li>
            <router-link :to="{ name:'capability'}">{{ $t('nav_capability') }}</router-link>
          </li>

          <li>
            <router-link :to="{ name:'career-train' }">{{ $t('nav_career') }}</router-link>
          </li>

          <li>
            <router-link :to="{ name:'about' }">{{ $t('nav_about') }}</router-link>
          </li>
          <!-- <li>
            <router-link :to="{ name:'pravicy-policy' }" v-html="$t('nav_privacy')">隱私政策</router-link>
          </li>
          <li>
            <router-link :to="{ name:'terms' }" v-html="$t('nav_terms')">使用條款</router-link>
          </li> -->

          <!-- <li>
              <router-link :to="{ name:'dealer-resource' }" v-html="$t('nav_dealer')">夥伴專區</router-link>
          </li> -->

          <!-- <li>
              <router-link :to="{ name:'downloads' }" v-html="$t('nav_downloads')">資源下載</router-link>
          </li> -->
        </ul>

        <hr>
      </div>

      <div class="icon-list">
        <!-- <div class="icon-list-box">
            <i class="la la-envelope"></i>
            <a
              href="#"
              data-notification-link="contact"
              v-html="$t('nav_contact')"
              @click.prevent="removeMactive"
            >聯絡與洽詢</a>
        </div> -->

        <div class="icon-list-box">
          <i class="la la-envelope"></i>
          <router-link :to="{name:'contact'}">{{ $t('nav_contact') }}</router-link>
        </div>

        <div class="icon-list-box">
          <i class="la la-search"></i>

          <a href="#" data-notification-link="search">{{ $t('nav_searchSite') }}</a>

          <!-- <div class="search-input h5">全站搜尋</div> -->
        </div>

        <div class="icon-list-box">
          <i class="la la-globe"></i>

          <select v-model="currLang" class="la-select" @change="switchLang">
            <option value="en">English</option>
            <option value="tw">繁體中文</option>
            <option value="cn">简体中文</option>
            <option value="de">Deutsch</option>
            <option value="jp">日本語</option>
            <option value="hu">Magyar</option>
          </select>
        </div>
      </div>
    </div>

    <div class="nav-sidebar-column-toggle visible-xs visible-sm m-header" style="cursor: default;">
      <router-link :to="{name:'home'}" class="m-header__logo">
        <svg width="146px" height="29px" viewBox="0 0 146 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="templete-real" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-870.000000, -2033.000000)">
              <g transform="translate(870.000000, 2033.000000)">
                <path d="M118,26.5014237 C118,27.8816913 111.955644,29 104.502061,29 C97.0429815,29 91,27.8824032 91,26.5014237 C91,25.1197323 97.0429815,24 104.502061,24 C111.955644,24.0007118 118,25.1197323 118,26.5014237 Z" id="Path" fill="#A7A9AC"></path>
                <path d="M104,0 C96.2691798,0 90,4.92450697 90,11.0013817 C90,17.0761839 96.2691798,22 104,22 C111.732882,22 118,17.0761839 118,11.0013817 C118,4.92450697 111.732882,0 104,0 Z M104.217837,16.5863585 C99.8899524,16.5863585 96.3811908,14.1600301 96.3811908,11.1706444 C96.3811908,8.17849516 99.8899524,5.75493029 104.217837,5.75493029 C108.549158,5.75493029 112.059294,8.17849516 112.059294,11.1706444 C112.059294,14.1600301 108.549158,16.5863585 104.217837,16.5863585 Z M72.4176664,10.6642676 L72.4176664,15.0704911 L75.6170821,15.0704911 C76.7637844,15.0704911 77.5624417,14.877132 78.0096351,14.4890226 C78.4602474,14.1002177 78.6831603,13.5458752 78.6831603,12.8252994 C78.6831603,12.1492379 78.4602474,11.6185436 78.0096351,11.2380852 C77.5617579,10.854149 76.7795114,10.6642676 75.6656306,10.6642676 L72.4176664,10.6642676 Z M65,29 L65,6 L78.778206,6 C81.0729782,6 82.8378194,6.55295149 84.0672593,7.65607234 C85.2953316,8.76127979 85.9114192,10.128009 85.9114192,11.7527821 C85.9114192,13.1153381 85.4724312,14.285926 84.5951389,15.2652413 C84.0070865,15.9155679 83.1496239,16.4260917 82.0220675,16.7995948 C83.7308386,17.193964 84.9862622,17.8741986 85.7903898,18.8416899 C86.59862,19.8091811 87,21.0249788 87,22.4904742 C87,23.6728862 86.7134954,24.7377525 86.1398023,25.6885509 C85.5661093,26.6379581 84.7804438,27.3933108 83.7855411,27.9476533 C83.1687698,28.2912483 82.2381426,28.5353816 80.9936595,28.6877041 C79.3354883,28.8970606 78.2359669,29 77.6957792,29 L65,29 Z M72.4176664,19.4106387 L72.4169827,19.4106387 L72.4169827,24.0769929 L76.1777833,24.0769929 C77.4468826,24.0769929 78.3433207,23.8592899 78.8636787,23.4259707 C79.3840368,22.9940426 79.6459253,22.4097919 79.6459253,21.677392 C79.6459253,20.9985484 79.3881395,20.4525523 78.8712003,20.0338394 C78.3569963,19.6199952 77.4523528,19.4106387 76.1613725,19.4106387 L72.4176664,19.4106387 Z M26.0021748,29 L26,6 L32.9724524,6 L33,29 L26.0021748,29 Z M43.8294444,11.5096541 L43.8294444,28.9714164 L37,29 L37,6 L43.2153109,6 L52.4601147,6 C52.4601147,6 60,6 60,13.0378285 L60,29 L53.3226932,29 L53.3226932,13.4184778 C53.3226932,13.4184778 53.3059441,11.5096541 49.7307097,11.5096541 C46.1554753,11.5096541 43.8294444,11.5096541 43.8294444,11.5096541 Z M129.827689,11.5096329 L129.827689,28.9714346 L123,29 L123,6 L129.213462,6 L138.458971,6 C138.458971,6 146,6 146,13.0375318 L146,29 L139.322378,29 L139.322378,13.4186356 C139.322378,13.4186356 139.304928,11.5096329 135.729849,11.5096329 C132.154073,11.5096329 129.827689,11.5096329 129.827689,11.5096329 Z M22.1464252,11.3692238 L22.1217554,11.3901455 L8.88323986,11.3901455 C7.18666299,11.206034 6.22383623,12.2542147 6.24286721,13.4007277 C6.27740492,15.3325045 8.98050933,15.1232868 8.98050933,15.1232868 C8.98050933,15.1232868 12.3863504,15.1232868 14.7638136,15.1232868 C18.1414606,15.1232868 23,16.6470891 23,22.1592784 C23,28.8598241 15.3481352,29 15.3481352,29 L0,29 L0,23.7995452 C0,23.7995452 12.6069688,23.765373 14.3895376,23.7995452 C15.2508657,23.8176774 16.9143146,23.3476349 16.7803929,21.7701334 C16.6218014,19.9025167 14.4409917,20.0552456 14.4409917,20.0552456 L8.46032913,20.0768648 C6.91529527,20.0768648 0.184671018,19.3585506 0.184671018,13.0359915 C0.184671018,6.09833232 7.95495081,6 7.95495081,6 L22.1464252,6.00488175 L22.1464252,11.3692238 Z" id="Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
              </g>
            </g>
          </g>
        </svg>
      </router-link>

      <i class="stack-menu"></i>
    </div>
  </div>
</template>
<style lang="less">
.m-header .stack-menu{
  left: 0;
  padding: 0 15px;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}
@media screen and (min-width: 992px){
  .nav-sidebar-column{
    width: 275px!important;
  }
  .nav-container.nav-container--sidebar + .main-container{
    width:calc(100% - 275px)!important;
  }
  .main-list.menu-vertical{
    margin-bottom: 12px!important;
  }
}

.main-list.menu-vertical *{
  white-space: wrap!important;
  line-height: 1.4;
}
.nav-sidebar-column .main-list > li{
  margin: 18px 0!important;
}
.secondary-list.menu-vertical a{
  display: block;
  padding: 3px 0;
}
.dropdown__content{
  max-width: 100%;
}
.icon-list a{
  padding:7px 0 7px 10px!important;
}

.header__hr{
  margin-bottom: 10px!important;
}



.nav-sidebar-column .main-list .dropdown .menu-vertical li.dropdown{
  font-size: 1rem!important;
}
.dropdown.sub .dropdown__content{
  padding-bottom: 0;
}
.menu-vertical li.dropdown::after{
  display: none!important;;
}
.dropdown{
  > .dropdown__trigger{
    &::after{
      content: '\E80C';
      font-family: 'stack-interface';
      font-size: 1.125rem!important;
      transition: 0.3s ease;
      display: inline-block;
      bottom: 0!important;
      margin-left: 10px;
      transform: rotate(90deg);
      opacity: 0.15;
    }
  }
}
.dropdown--active{
  > .dropdown__trigger{
    &::after{
      transform: rotate(-90deg);
      opacity: 0.6;
    }
  }
}
</style>
<script>
  import { mapState, mapActions, mapGetters } from "vuex";
  // import apibase from "@/static/apibase.js";
  // import axios from "axios";
  import $ from "jquery";
  import {readCookie,createCookie} from "@/libs/js/cookie.js"

  export default {
    data() {
      return {
        productCats: null,
        solutionsCats: null,
        // csrPage: null,//should be removed
        currLang: this.getLang(),
        searchOn: false,
        langsOn: false,
        searching: false,
        placeholderValue: '全站搜尋',
        // headerPreview:false
      };
    },

    methods: {
      ...mapActions([
        "setLang", 
        // "fetchCsrPage",//should be removed
        "fetchNavigation"
      ]),
      ...mapGetters(["getLang"]),

      // removeMactive() {
      //   if ($('#app').hasClass('m-active')) $('#app').removeClass('m-active');
      // },
      // toggleNav() {
      //   $('#app').toggleClass('m-active');
      // },
      inputKeyword() {
        this.searchOn = !this.searchOn;
        this.langsOn = false;
      },

      selectLang() {
        this.langsOn = !this.langsOn;
        this.searchOn = false;
      },

      switchLang() {
        this.setLang(this.currLang);
      },

      focus() {
        this.searching = true;
        this.placeholderValue = '';
      },

      focusout() {
        this.searching = false;
        this.placeholderValue = '全站搜尋';
      },

      updateDropdown(){
        this.$nextTick(() => {
          var _navItems=document.querySelectorAll('.header li');
          for(var k in _navItems){
            if(_navItems[k].dataset&&_navItems[k].dataset.uri&&_navItems[k].dataset.uri==this.$route.path){
              var _parents=$(_navItems[k]).parents();
              for(var j in _parents){
                if(_parents[j].classList&&_parents[j].classList.contains('dropdown')){
                  _parents[j].classList.add('dropdown--active');
                }
              }
            }
          }
        });
      },
    },

    computed: {
      ...mapState([
        'productCate', 
        'solutionCate', 
        // 'csrPageItem', //should be removed
        'navTrends', 
        'navProducts', 
        'navEsg',
        'navGovernance'
      ]),

      navOptions() {
        if (this.navProducts != null) 
        {
          let result = {};
          result.children = [...this.navProducts];
          result.children.unshift({ children: null, title: this.$t('ui_allCategory'), uri: 'all' });
          return result;
        }
      }
    },

    watch: {
      productCate(val) {
        this.productCats = val;
      },

      solutionCate(val) {
        this.solutionsCats = val;
      },

      //should be removed
      // csrPageItem(val) {
      //   this.csrPage = val;
      //   this.$nextTick(() => {
      //     this.$themeInitDropdown();
      //   });
      // },

      navEsg(val){
        // console.log('navEsg',val);
        this.$nextTick(() => {
          this.$themeInitDropdown();
          this.updateDropdown();
        });
      },
      navGovernance(val){
        // console.log('navGovernance',val);
        this.$nextTick(() => {
          this.$themeInitDropdown();
          this.updateDropdown();
        });
      },
    },

    created() {
      var _this=this
      // this.fetchCsrPage();//should be removed
      _this.fetchNavigation()
    },
    mounted() {
      // this.$initThemeJs();
      this.$themeInitDropdown();
      $(document).on('click', function (e) {
        if ($(e.target).is('.stack-menu')) {
          $('#app').toggleClass('m-active');
        } else {
          if ($('#app').hasClass('m-active')) $('#app').removeClass('m-active');
        }
      });
      $(window).on('resize', function () {
        if($(window).width()>991){
          if ($('#app').hasClass('m-active')) $('#app').removeClass('m-active');
        }
      });

      // if(this.$route.query&&this.$route.query.newnav!=undefined){
      //   createCookie('newnav',this.$route.query.newnav,2);
      // }
      // if(readCookie('newnav')=='true'){
      //   this.headerPreview=true;
      // }else{
      //   this.headerPreview=false;
      // }
    }
  };
</script>